module.exports = __webpack_public_path__ + "static/img/006 7.07381bcc.jpg";